import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ReceiptStatusCellContent: React.FC<ReceiptStatusCellContent.Props> = ({
	item,
	language,
}) => {
	const { t } = useTranslation();

	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell =
			item?.cellsForTable?.[ColumnId.ReceiptStatus];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item.receipt, t);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.cellsForTableSettings?.lang,
		item.receipt,
		language,
		t,
	]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			textColor={backgroundColor ? "#fff" : undefined}
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace ReceiptStatusCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default ReceiptStatusCellContent;
